import React from 'react';
import styled from 'styled-components/macro';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  margin-bottom: 16px;
`;

const DatePickersWrapper = styled.div`
  margin-top: 16px;
  @media screen and (max-width: 520px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .react-datepicker__month--selected,
  .react-datepicker__year-text--selected {
    background: #2352b0;
    &:hover {
      background: #2352b0;
    }
  }
  .month-picker,
  .year-picker {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    height: 24px;
    border: 1px solid #d0d3d9;
    border-radius: 4px;
    padding: 8px 12px;
    display: block;
  }
  .month-picker {
    width: 184px;

    @media screen and (max-width: 375px) {
      width: 160px;
    }
  }
  .year-picker {
    margin-left: 8px;
    width: 96px;
    @media screen and (max-width: 375px) {
      width: 80px;
    }
  }
  .date-picker {
    width: 100%;
    border: 0;
    margin-top: -10px;
    margin-left: -20px;
    @media screen and (max-width: 520px) {
      margin-left: 0;
    }
    .react-datepicker__header {
      padding: 0;
      background: none;
      border: 0;
    }
    .react-datepicker__day-name {
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      color: ${props => props.theme.colors.secondary[100]};
      padding: 10px;

      @media screen and (max-width: 375px) {
        padding: 5px;
      }
    }
    .react-datepicker__day {
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 20px;
      color: ${props => props.theme.colors.neutral[80]};
      padding: 10px;
      &.react-datepicker__day--disabled {
        color: ${props => props.theme.colors.neutral[40]};
      }
      &.react-datepicker__day--selected {
        color: ${props => props.theme.colors.white[100]};
        background-color: #2352b0;
      }
      @media screen and (max-width: 375px) {
        padding: 5px;
      }
    }
  }
`;

type Props = {
  date?: Date;
  onDateChange: (date: Date) => void;
};
export const DatePickers = ({ onDateChange, date }: Props) => {
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);
  return (
    <DatePickersWrapper>
      <Header>
        <DatePicker
          selected={date}
          onChange={onDateChange}
          showMonthYearPicker
          dateFormat='MMMM'
          yearItemNumber={9}
          minDate={new Date(today.getFullYear(), today.getMonth(), 1)}
          className='month-picker'
        />
        <DatePicker
          selected={date}
          onChange={onDateChange}
          showYearPicker
          dateFormat='yyyy'
          yearItemNumber={9}
          minDate={new Date(today.getFullYear(), 0, 1)}
          className='year-picker'
        />
      </Header>
      <DatePicker
        selected={date}
        onChange={onDateChange}
        minDate={tomorrow}
        inline
        calendarClassName='date-picker'
        renderCustomHeader={() => <></>}
        calendarStartDay={1}
        formatWeekDay={nameOfDay => nameOfDay.substr(0, 1)}
      />
    </DatePickersWrapper>
  );
};
